import type { Organisation } from '@/types/models/organisation';

const initialState = () => ({
  federatedOrganisations: [] as Organisation[],
});

export const state = initialState();
export type ZeusFederatedState = ReturnType<typeof initialState>;

export const mutations = {
  SET_FEDERATED_ORGS(state: ZeusFederatedState, orgs: Organisation[]) {
    state.federatedOrganisations = [...orgs];
  },
  ADD_FEDERATED_ORG(state: ZeusFederatedState, org: Organisation) {
    const ind = state.federatedOrganisations.findIndex((item) => item.orgID === org.orgID);
    if (ind > -1) {
      state.federatedOrganisations.splice(ind, 1, org);
    } else {
      state.federatedOrganisations.push(org);
    }
  },
  CLEAR_STATE(state: ZeusFederatedState) {
    Object.assign(state, initialState());
  },
};
